<template>
  <div class="user-content-section">
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("notifications") }}</div>
      </h2>
    </div>
    <div class="notification-list" v-if="notification">
      <div
        class="notification-item"
        v-for="(item, index) in notification"
        :key="index"
        :class="{ 'notification-item-active': !item.show_status }"
      >
        <div class="notification-shape">
          <div class="notification-content">
            <h3>{{ item.title }}</h3>
            <p v-if="item.category">
              <i class="fa-book"></i>{{ item.category }}
            </p>
          </div>
          <div class="notification-btn">
            <p>
              <i class="fa-clock"></i>
              {{
                parseInt(item.time / 60 / 24)
                  ? parseInt(item.time / 60 / 24) + ` ` + $t("days_ago")
                  : $t("today")
              }}
            </p>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
    <div class="notification-list" v-else>
      <div class="notification-item notification-item-active">
        <div class="notification-shape">
          <i v-cyr2lat="$store.getters.lang">
            {{ $t("no_new_notifications") }}
            <br />
            <br />
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Xabarnoma",

  data() {
    return {
      id_show_status: [],
    };
  },
  computed: {
    notification() {
      return this.$store.getters.getNotifications;
    },
  },
};
</script>
